export default __webpack_public_path__ + "static/media/fasad_pribici2.2a8fd4ef.jpg";